import { getStore } from "../store/store";
import { mutatorAction } from "satcheljs";

const resetMessageAdListSelectionMutator: () => void = mutatorAction("resetMessageAdListSelection", function (): void {
    const store = getStore();
    if (store) {
        store.selectedAdId = "";
    }
});
export default resetMessageAdListSelectionMutator;
